"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointOfInterest = exports.EPlannStatus = exports.DefaultIconSelect = exports.DefaultIconsPoiMapping = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
exports.DefaultIconsPoiMapping = new Map([
    ["boar", "icnSchwarzwild"],
    ["bolt.fill", "icon-bolt"],
    ["geoobjekt/bolt.fill", "icon-bolt"],
    ["geoobjekt_bolt.fill", "icon-bolt"],
    ["doc.text.magnifyingglass", "icon_doc-text_search"],
    ["geoobjekt/doc.text.magnifyingglass", "icon_doc-text_search"],
    ["geoobjekt_doc.text.magnifyingglass", "icon_doc-text_search"],
    ["drueckjagdbock", 'diwima_smp_drueckjagdbock_al'],
    ["geoobjekt/drueckjagdbock", "diwima_smp_drueckjagdbock_al"],
    ["geoobjekt_drueckjagdbock", "diwima_smp_drueckjagdbock_al"],
    ["drückjagdbock", 'diwima_smp_drueckjagdbock_al'],
    ["geoobjekt/drückjagdbock", "diwima_smp_drueckjagdbock_al"],
    ["geoobjekt_drückjagdbock", "diwima_smp_drueckjagdbock_al"],
    ["drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
    ["geoobjekt/drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
    ["geoobjekt_drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
    ["drückjagdstand", "diwima_smp_drueckjagdbock_al"],
    ["geoobjekt/drückjagdstand", "diwima_smp_drueckjagdbock_al"],
    ["geoobjekt_drückjagdstand", "diwima_smp_drueckjagdbock_al"],
    ["erdsitz", 'diwima_smp_erdsitz-maj'],
    ["geoobjekt/erdsitz", 'diwima_smp_erdsitz-maj'],
    ["geoobjekt_erdsitz", 'diwima_smp_erdsitz-maj'],
    ["flache-gewaesser", "icon_flache-gewaesser"],
    ["geoobjekt/flache-gewaesser", "icon_flache-gewaesser"],
    ["geoobjekt_flache-gewaesser", "icon_flache-gewaesser"],
    ["hochsitz", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt/hochsitz", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt_hochsitz", 'diwima_smp_hochsitz-maj'],
    ["house.circle.fill", "icon_house_circle_fill"],
    ["geoobjekt/house.circle.fill", "icon_house_circle_fill"],
    ["geoobjekt_house.circle.fill", "icon_house_circle_fill"],
    ["jagdhuette", "diwima_smp_jagdhuette-maj"],
    ["geoobjekt/jagdhuette", "diwima_smp_jagdhuette-maj"],
    ["geoobjekt_jagdhuette", "diwima_smp_jagdhuette-maj"],
    ["Kadaver", "diwima_ic_schwarzwild"],
    ["geoobjekt/Kadaver", "diwima_ic_schwarzwild"],
    ["geoobjekt_Kadaver", "diwima_ic_schwarzwild"],
    ["kanzel.geschlossen", 'diwima_smp_hochsitz-maj'], //5k
    ["geoobjekt/kanzel.geschlossen", 'diwima_smp_hochsitz-maj'], //5k
    ["geoobjekt_kanzel.geschlossen", 'diwima_smp_hochsitz-maj'], //5k
    ["kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'], //5k
    ["geoobjekt/kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'], //5k
    ["geoobjekt_kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'], //5k
    ["kanzel.offen", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt/kanzel.offen", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt_kanzel.offen", 'diwima_smp_hochsitz-maj'],
    ["kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt/kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt_kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
    ["Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt/Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
    ["geoobjekt_Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
    ["kirrung", 'diwima_smp_kirung-maj'],
    ["geoobjekt/kirrung", 'diwima_smp_kirung-maj'],
    ["geoobjekt/kirung", 'diwima_smp_kirung-maj'],
    ["geoobjekt_kirrung", 'diwima_smp_kirung-maj'],
    ["leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
    ["geoobjekt/leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
    ["geoobjekt_leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
    ["leiter-baum", 'diwima_smp_leiter-baum-maj'],
    ["geoobjekt/leiter-baum", 'diwima_smp_leiter-baum-maj'],
    ["geoobjekt_leiter-baum", 'diwima_smp_leiter-baum-maj'],
    ["leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
    ["geoobjekt/leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
    ["geoobjekt_leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
    ["leiter-offen", 'diwima_smp_leiter-offen-maj'],
    ["geoobjekt/leiter-offen", 'diwima_smp_leiter-offen-maj'],
    ["geoobjekt_leiter-offen", 'diwima_smp_leiter-offen-maj'],
    ["leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
    ["geoobjekt/leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
    ["geoobjekt_leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
    ["location.magnifyingglass", "icon_location_magnifyingglas"],
    ["geoobjekt/location.magnifyingglass", "icon_location_magnifyingglas"],
    ["geoobjekt_location.magnifyingglass", "icon_location_magnifyingglas"],
    ["maiskolben", "icon_maiskolben"],
    ["geoobjekt/maiskolben", "icon_maiskolben"],
    ["geoobjekt_maiskolben", "icon_maiskolben"],
    ["parkplatz", "icon_parkplatz"], //+
    ["geoobjekt/parkplatz", "icon_parkplatz"], //+
    ["geoobjekt_parkplatz", "icon_parkplatz"], //+
    ["pin", "icon-pin"],
    ["geoobjekt/pin", "icon-pin"],
    ["geoobjekt_pin", "icon-pin"],
    ["pirschweg", "icon_pirschweg"], //+
    ["geoobjekt/pirschweg", "icon_pirschweg"], //+
    ["geoobjekt_pirschweg", "icon_pirschweg"], //+
    ["fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["Fundort Probe", "diwima_smp_reagenzglas_orange"], //
    ["geoobjekt/fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["geoobjekt_fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["powerplug.fill", "icon_powerplug"],
    ["geoobjekt/powerplug.fill", "icon_powerplug"],
    ["geoobjekt_powerplug.fill", "icon_powerplug"],
    ["salzlecke", 'icon-salzlecke'],
    ["geoobjekt/salzlecke", 'icon-salzlecke'],
    ["geoobjekt_salzlecke", 'icon-salzlecke'],
    ["schoepfstelle", "icon_schoepfstelle"],
    ["geoobjekt/schoepfstelle", "icon_schoepfstelle"],
    ["geoobjekt_schoepfstelle", "icon_schoepfstelle"],
    ["sammelplatz", "icon_sammelplatz"],
    ["geoobjekt/sammelplatz", "icon_sammelplatz"],
    ["geoobjekt_sammelplatz", "icon_sammelplatz"],
    ["selectedPoint", "icon-pin"],
    ["geoobjekt/selectedPoint", "icon-pin"],
    ["geoobjekt_selectedPoint", "icon-pin"],
    ["suhle", "icon_suhle"],
    ["geoobjekt/suhle", "icon_suhle"],
    ["geoobjekt_suhle", "icon_suhle"],
    ["tablecells", "icon-table"],
    ["geoobjekt/tablecells", "icon-table"],
    ["geoobjekt_tablecells", "icon-table"],
    ["tor", "icon_tor"],
    ["geoobjekt/tor", "icon_tor"],
    ["geoobjekt_tor", "icon_tor"],
    ["undefined", "undefined"],
    ["wasserlitze", "icon-wasserlitze"],
    ["geoobjekt/wasserlitze", "icon-wasserlitze"],
    ["geoobjekt_wasserlitze", "icon-wasserlitze"],
    ["wildkamera", "icon-wildkamera"],
    ["geoobjekt/wildkamera", "icon-wildkamera"],
    ["geoobjekt_wildkamera", "icon-wildkamera"],
    ["wildkammer", 'diwima_smp_wildkammer-maj'],
    ["geoobjekt/wildkammer", 'diwima_smp_wildkammer-maj'],
    ["geoobjekt_wildkammer", 'diwima_smp_wildkammer-maj'],
]);
exports.DefaultIconSelect = new Map([
    // ["fundort probe", "diwima_smp_reagenzglas_orange"],
    // ["Fundort Probe", "diwima_smp_reagenzglas_orange"],
    // ["undefined","undefined"],
    ["bolt.fill", "icon-bolt"],
    ["doc.text.magnifyingglass", "icon_doc-text_search"],
    ["drueckjagdbock", 'diwima_smp_drueckjagdbock_al'],
    // ["drückjagdbock", 'diwima_smp_drueckjagdbock_al'],
    // ["drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
    // ["drückjagdstand","diwima_smp_drueckjagdbock_al"],
    ["erdsitz", 'diwima_smp_erdsitz-maj'],
    ["flache-gewaesser", "icon_flache-gewaesser"],
    ["hochsitz", 'diwima_smp_hochsitz-maj'],
    ["house.circle.fill", "icon_house_circle_fill"],
    ["jagdhuette", "diwima_smp_jagdhuette-maj"],
    // ["Kadaver","diwima_ic_schwarzwild"],
    // ["kanzel.geschlossen", 'diwima_smp_hochsitz-maj'],
    // ["kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'],
    // ["kanzel.offen", 'diwima_smp_hochsitz-maj'],
    // ["kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
    // ["Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
    ["kirrung", 'diwima_smp_kirung-maj'],
    // ["leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
    ["leiter-baum", 'diwima_smp_leiter-baum-maj'],
    // ["leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
    ["leiter-offen", 'diwima_smp_leiter-offen-maj'],
    // ["leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
    ["location.magnifyingglass", "icon_location_magnifyingglas"],
    // ["maiskolben","icon_maiskolben"],
    ["parkplatz", "icon_parkplatz"],
    ["pin", "icon-pin"],
    ["pirschweg", "icon_pirschweg"],
    // ["fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["powerplug.fill", "icon_powerplug"],
    ["salzlecke", 'icon-salzlecke'],
    ["schoepfstelle", "icon_schoepfstelle"],
    ["sammelplatz", "icon_sammelplatz"],
    // ["selectedPoint","icon-pin"],
    ["suhle", "icon_suhle"],
    ["tablecells", "icon-table"],
    ["tor", "icon_tor"],
    ["wasserlitze", "icon-wasserlitze"],
    ["wildkamera", "icon-wildkamera"],
    ["wildkammer", 'diwima_smp_wildkammer-maj'],
]);
var EPlannStatus;
(function (EPlannStatus) {
    EPlannStatus["INPLANNING"] = "inPlanning";
    EPlannStatus["PENDEXECUTION"] = "pendingExecution";
    EPlannStatus["INPROGRESS"] = "inProgress";
    EPlannStatus["TESTED"] = "tested";
    EPlannStatus["OVERDUE"] = "overdue";
})(EPlannStatus || (exports.EPlannStatus = EPlannStatus = {}));
class PointOfInterest {
    constructor(additionalContext) {
        this.className = "PointOfInterest";
        this.identifier = undefined;
        this.contextId = undefined;
        this.contextIds = undefined;
        this.contextIdRights = undefined;
        this.createdOnDeviceName = undefined;
        this.revision = undefined;
        this.area = undefined;
        this.length = undefined;
        this.createdByUserId = undefined;
        this.createdByUserDisplayName = undefined;
        this.locationCoordinates = undefined;
        this.locationHeight = undefined;
        this.locationHeading = undefined;
        this.additionalHeadings = undefined;
        this.type = undefined;
        this.typeTitle = undefined;
        this.shortName = undefined;
        this.shortID = undefined;
        this.comment = undefined;
        this.commentUsage = undefined;
        this.commentMaintenance = undefined;
        this.usageStatus = undefined;
        this.maxPersonCount = undefined;
        this.testIntervalDays = undefined;
        this.lastTestDate = undefined;
        this.yearOfContruction = undefined;
        this.tagid = undefined;
        this.rfid_uid = undefined;
        this.huntingDistrictId = undefined;
        this.huntingDistrictName = undefined;
        this.nextTestDate = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
        // ??
        this.imageCount = undefined;
        this.shootRegions = undefined;
        this.additionalData = undefined;
        this.externalReference = undefined;
        this.category = undefined;
        this.notificationChannel = undefined;
        this.context = undefined;
        this.contentType = undefined;
        this.encodedContent = undefined;
        this.fillColor = undefined;
        this.borderColor = undefined;
        this.lineWidth = undefined;
        this.planningStatus = undefined;
        this.context = additionalContext;
    }
    setFromAny(element) {
        const { identifier, contextId, contextIds, contextIdRights, notificationChannel, creationDate, updateTimestamp, revision, createdByUserId, createdByUserDisplayName, createdOnDeviceName, locationCoordinates, shootRegions, additionalData, shortName, shortID, type, typeTitle, huntingDistrictId, huntingDistrictName, usageStatus, maxPersonCount, testIntervalDays, lastTestDate, comment, commentUsage, commentMaintenance, locationHeight, locationHeading, yearOfContruction, externalReference, additionalHeadings, tagid, rfid_uid, contentType, encodedContent, category, lineWidth, imageCount, pictureURLlinks, area, length, planningStatus, nextTestDate } = element;
        // set title is id ist present?
        if (!typeTitle && this.type)
            this.typeTitle = this.getTypeTitle();
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.contextIds = contextIds ? contextIds : this.contextIds;
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights;
        this.revision = revision ? revision : this.revision;
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId;
        this.createdByUserDisplayName = createdByUserDisplayName ? createdByUserDisplayName : this.createdByUserDisplayName;
        this.createdOnDeviceName = createdOnDeviceName ? createdOnDeviceName : this.createdOnDeviceName;
        this.locationCoordinates = locationCoordinates ? locationCoordinates : this.locationCoordinates;
        this.typeTitle = typeTitle ? typeTitle : this.typeTitle;
        this.shootRegions = shootRegions ? shootRegions : this.shootRegions;
        this.additionalData = additionalData ? additionalData : this.additionalData;
        this.shortName = shortName ? shortName : this.shortName;
        this.shortID = shortID ? shortID : this.shortID;
        this.type = type ? type : this.type;
        this.locationHeading = locationHeading ? locationHeading : this.locationHeading;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.usageStatus = usageStatus ? usageStatus : this.usageStatus;
        this.maxPersonCount = maxPersonCount ? maxPersonCount : this.maxPersonCount;
        this.testIntervalDays = testIntervalDays ? testIntervalDays : this.testIntervalDays;
        this.lastTestDate = lastTestDate ? lastTestDate : this.lastTestDate;
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId;
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName;
        this.comment = comment ? comment : this.comment;
        this.commentUsage = commentUsage ? commentUsage : this.commentUsage;
        this.commentMaintenance = commentMaintenance ? commentMaintenance : this.commentMaintenance;
        this.locationHeight = locationHeight ? locationHeight : this.locationHeight;
        this.yearOfContruction = yearOfContruction ? yearOfContruction : this.yearOfContruction;
        this.externalReference = externalReference ? externalReference : this.externalReference;
        this.additionalHeadings = additionalHeadings ? additionalHeadings : this.additionalHeadings;
        this.tagid = tagid ? tagid : this.tagid;
        this.rfid_uid = rfid_uid ? rfid_uid : this.rfid_uid;
        this.category = category ? category : this.category;
        this.notificationChannel = notificationChannel ? notificationChannel : this.notificationChannel;
        this.contentType = contentType ? contentType : undefined;
        this.encodedContent = encodedContent ? encodedContent : undefined;
        this.lineWidth = lineWidth ? lineWidth : undefined,
            this.imageCount = imageCount ? imageCount : undefined,
            this.pictureURLlinks = pictureURLlinks ? pictureURLlinks : undefined;
        this.area = area ? area : undefined;
        this.length = length ? length : undefined;
        this.planningStatus = planningStatus ? planningStatus : undefined;
        this.nextTestDate = nextTestDate ? nextTestDate : undefined;
    }
    getListItemTitle() {
        return this.shortName ? this.shortName : "No name configured";
    }
    searchFilter(filter) {
        const str = `${this.shortName}${this.typeTitle}${this.type}${this.huntingDistrictName}`.toLowerCase();
        return str.includes(filter);
    }
    getTypeTitle() {
        var _a, _b;
        if (this.typeTitle)
            return this.typeTitle;
        if (!this.context || !this.type)
            return undefined;
        const settingRef = network_constants_1.NetworkConstants.SETTING_GEO_TYPE;
        const setting = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.settingsMap) === null || _b === void 0 ? void 0 : _b.get(settingRef);
        if (!setting)
            return this.type;
        const type = setting.values.find(el => el.identifier == this.type);
        if (!type)
            return this.type;
        return type.title;
    }
    getIconName() {
        if (!this.type)
            return undefined;
        return exports.DefaultIconsPoiMapping.get(this.type); // ?? DefaultIconsPoiMapping.get('pin')
    }
    getFeature(strUnkown, iconName) {
        const location = this.locationCoordinates;
        if (!location)
            return undefined;
        let { identifier, shortName, type, 
        // typeTitle, 
        usageStatus, creationDate, maxPersonCount } = this;
        let icon = exports.DefaultIconsPoiMapping.get(iconName);
        // let icon: string|undefined = this.getIconName()
        let typeTitle = this.getTypeTitle();
        if (!icon) {
            icon = exports.DefaultIconsPoiMapping.get('pin');
        }
        return {
            type: "Feature",
            properties: {
                identifier,
                shortName,
                icon,
                type,
                typeTitle: typeTitle ? typeTitle : strUnkown,
                creationDate,
                usageStatus,
                maxPersonCount,
            },
            geometry: {
                type: 'Point',
                coordinates: [location.longitude, location.latitude]
            }
        };
    }
    getFeatures() {
        let features = [];
        var geometry = { type: 'Polygon', coordinates: [] };
        if (this.encodedContent) {
            var properties = {};
            const encodedContent = this.encodedContent.split(" ");
            let pairs;
            pairs = encodedContent.reduce(function (result, value, indexV, array) {
                if (indexV % 2 === 0) {
                    const splited = array.slice(indexV, indexV + 2);
                    var lat = +splited[1];
                    var lng = +splited[0];
                    const valueLatLng = [lat, lng];
                    result.push(valueLatLng);
                }
                return result;
            }, []);
            if (this.contentType == 'polygon') {
                geometry = {
                    type: 'MultiPolygon',
                    coordinates: [[pairs]]
                };
            }
            if (this.contentType == 'line') {
                geometry = {
                    type: 'MultiLineString',
                    coordinates: [pairs]
                };
            }
            var feature = {
                type: "Feature",
                geometry: geometry,
                id: this.identifier,
                properties: properties,
            };
            features.push(feature);
        }
        return features;
    }
    getGeoJsonFromFeatures(features) {
        if (!features)
            return undefined;
        const geoJsonBase = {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': features
            }
        };
        return geoJsonBase;
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        const list = ["context", "className"];
        if (list.includes(key))
            return false;
        else
            return true;
    }
}
exports.PointOfInterest = PointOfInterest;
PointOfInterest.className = "PointOfInterest";
